import styled from "@emotion/styled";
import { styled as MuiStyled } from "@mui/material/styles";
import { Button, InputBase } from "@mui/material";

//*************************************************//
//********************Emotion**********************//
export const FooterWrapper = styled.footer`
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: #fff;
  padding-top: 67px;
  .title {
    font-weight: 800;
    font-size: 20px;
    line-height: 48px;
    color: #ffffff;
    text-transform: capitalize;
    /*margin-bottom: 15px;*/
  }
  .content {
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #ffffff;
  }

  form {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-wrap: wrap;
    button {
      flex: 0 0 auto;
    }
  }
  .contactDisc {
    display: flex;
    flex-direction: column;
  }
  .MuiDivider-root {
    border-color: rgb(211 218 235 / 10%);
  }

  .logoWrapper {
    position: relative;
    width: 144px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .info-content {
    p,
    ul,
    a {
      font-weight: 500;
      font-size: 13px;
      line-height: 30px;
      color: #a8b5d6;
      ${({ theme }) => ({
        [theme.breakpoints.down("md")]: {
          fontSize: 16,
          lineHeight: "28px",
        },
      })}
    }

    ul,
    p {
      color: #a8b5d6;
    }

    .head {
      color: #b9babc;
      margin-bottom: 8px;
    }

    span {
      display: block;
    }
    span.num {
      display: flex;
      span {
        direction: initial;
      }
    }
  }

  .subfooter {
    background: #e6e6e7;
    padding: 22px 16px;
    text-align: center;
    font-weight: 400;
    font-size: 11px;
    color: #8d8e91;
    margin-top: 38px;
  }

  ${({ theme }) => ({
    paddingTop: 30,
    [theme.breakpoints.down("md")]: {
      " form ": {
        justifyContent: "center",
      },
      " .contactDisc": { alignItems: "center" },
      " .content": {
        fontSize: 16,
      },
    },
  })}//&
  //  .MuiContainer-root
  //  .MuiGrid-container
  //  .MuiGrid-item:last-of-type
  //  .info-content {
  //  margin-left: 44px;
  //}
  //&
  //  .MuiContainer-root
  //  .MuiGrid-container
  //  .MuiGrid-item:nth-last-of-type(2)
  //  .info-content {
  //  margin-left: 100px;
  //}
`;

export const FooterLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 50px;
  & > div {
    flex: 1 1 auto;
  }
`;

//***************************************************//
//********************MuiStyled**********************//
export const SubscribeInput = MuiStyled(InputBase)(({ theme }) => ({
  width: "100%",
  maxWidth: 280,
  flex: "1 1 220px",
  "& .MuiInputBase-input": {
    fontFamily: "Inter, 'Open Sans', Roboto, sans-serif  !important",
    direction: "initial",
    background: "rgba(255, 255, 255, 0.1)",
    borderRadius: "54px",
    border: "1px solid transparent",
    padding: "9px 16px",
    marginRight: "20px",
    position: "relative",
    fontWeight: 400,
    fontSize: "13px",
    color: "#A8B5D6",
    transition: theme.transitions.create(["box-shadow"]),
    "&:focus": {
      boxShadow: "rgb(252 252 252 / 13%) 0 0 0 0.2rem",
    },
  },
  "&.Mui-error .MuiInputBase-input": {
    boxShadow: "rgb(252 252 252 / 13%) 0 0 0 0.2rem",
    "&:focus ": {
      boxShadow: "rgb(252 252 252 / 13%) 0 0 0 0.2rem",
    },
    "&:not(:focus)": {
      boxShadow: "rgb(242 54 60 / 75%) 0 0 0 0.2rem",
    },
  },
  "@media screen and (max-width: 368px)": {
    maxWidth: "100%",
    "& .MuiInputBase-input": {
      marginRight: 0,
      marginBottom: 10,
    },
  },
}));

export const SubscribeButton = styled(Button)(({ theme }) => ({
  padding: "9px 20px",
  background: "#ed1e24",
  borderRadius: 34,
  fontWeight: 500,
  fontSize: 14,
  color: "#ffffff",
  lineHeight: "initial",
  minWidth: 119,
  minHeight: 42,
  "&:disabled": {
    backgroundColor: "#900004",
  },
  "&:hover": {
    backgroundColor: "#f33339",
    borderColor: "#ed1e24",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#f33339",
    borderColor: "#ed1e24",
  },
  "@media screen and (max-width: 368px)": {
    width: "100%",
  },
}));
